
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-cogicon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-cogicon"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-cogicon__cog",attrs:{"d":"M5 14.19l1.54-1.06a4.89 4.89 0 001.31.56l.33 1.81h1.63l.33-1.86a5.38 5.38 0 001.34-.54L13 14.15 14.16 13l-1.06-1.53a5.46 5.46 0 00.57-1.34l1.83-.33V8.17l-1.83-.32a5.21 5.21 0 00-.56-1.33L14.16 5 13 3.83l-1.52 1.08a8.28 8.28 0 00-1.32-.54L9.82 2.5H8.19l-.34 1.87a4.87 4.87 0 00-1.3.53L5 3.84 3.87 4.92l1 1.64a4.53 4.53 0 00-.54 1.31L2.5 8.2v1.64l1.86.34a5 5 0 00.55 1.3L3.87 13z"}}),_c('path',{staticClass:"i-cogicon__c",attrs:{"d":"M8 10.1a1.33 1.33 0 001 .42 1.37 1.37 0 001-.37 1.51 1.51 0 00.33-.56l1.54.29.5.11-.15.41a3.84 3.84 0 01-.83 1.21 3.23 3.23 0 01-2.39.87 3.4 3.4 0 01-3.44-3.32V9a3.34 3.34 0 011-2.49 3.38 3.38 0 012.51-1 3.2 3.2 0 012.43 1 3.15 3.15 0 01.67 1 2.54 2.54 0 01.19.59l-2 .36A1.33 1.33 0 009 7.49a1.34 1.34 0 00-1 .43A1.6 1.6 0 007.57 9 1.53 1.53 0 008 10.1z"}})])
          )
        }
      }
    